import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
export default function TheDesignPhilosophy() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="13576" id="the-echelon-ethos" className="bg-background text-foreground relative overflow-hidden py-24 lg:py-32">
      {}
      <div className="container mx-auto px-6 md:px-12 lg:px-[200px]">
        <div ref={ref} className={`grid grid-cols-1 gap-16 lg:grid-cols-2 lg:gap-24 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="relative group aspect-[3/4] w-full overflow-hidden rounded-none bg-muted">
            {}
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1582385/img/pixelforge_founder_portrait_bw.png" alt="Echelon Soiree Curated Aesthetic" className="h-full w-full object-cover object-center grayscale opacity-90 transition-transform duration-1000 group-hover:scale-105" />
            {}
            <div className="pointer-events-none absolute inset-0 bg-secondary/5 mix-blend-multiply" />
            
            {}
            <div className="absolute inset-4 border border-foreground/5 pointer-events-none" />
          </div>

          {}
          <div className="relative flex flex-col justify-center">
            {}
            <div className="pointer-events-none absolute -right-12 top-0 bottom-0 flex items-center justify-center select-none opacity-5 overflow-hidden" aria-hidden="true">
              <span className="text-[8rem] font-serif font-light leading-none tracking-widest text-foreground [writing-mode:vertical-rl] whitespace-nowrap">
                SOIRÉE
              </span>
            </div>

            {}
            <div className="relative z-10 space-y-8">
              <div className="space-y-4">
                <h2 className="text-xs font-sans font-medium uppercase tracking-[0.2em] text-muted-foreground">
                  The Echelon Standard
                </h2>
                <h3 className="font-serif text-4xl font-light leading-tight text-foreground md:text-5xl">
                  Crafting atmospheres of <span className="italic text-foreground/80">timeless</span> sophistication.
                </h3>
              </div>

              <div className="space-y-6 text-lg leading-relaxed text-foreground/70 font-sans font-light">
                <p>
                  At Echelon Soirée, we don't simply plan events; we architect experiences. Our philosophy is rooted in the belief that true luxury is found in the invisible details—the silent coordination, the precise placement, and the intentional flow of a room.
                </p>
                <p>
                  We curate environments that speak to the senses with a quiet confidence. By distilling every concept down to its most elegant form, we reveal the inherent beauty of your celebration. Every gathering is a bespoke canvas where every stroke of design is purposeful and refined.
                </p>
                <p>
                  From intimate private dinners to expansive corporate galas, we bring a level of poise and architectural precision that transforms a single evening into a landmark memory for the discerning host.
                </p>
              </div>

              <div className="pt-4">
                <Button asChild variant="outline" className="border-foreground/20 rounded-none hover:bg-foreground hover:text-background transition-all uppercase tracking-widest text-[10px] h-14 px-10">
                  <Link to="/ExperiencePage">
                    View the Experience <ArrowRight className="ml-2 h-3 w-3" />
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}